import { Checkbox, Box, Text, InfoIcon } from '@wix/design-system';
import React__default, { useContext } from 'react';
import { RicosContext } from 'ricos-context';

const ZINDEX = 101e3;
const CheckboxWithInfoIcon = ({ checked, onChange, textContent, tooltipContent, dataHook }) => {
  const { t } = useContext(RicosContext);
  return /* @__PURE__ */ React__default.createElement(Checkbox, { dataHook, size: "small", checked, onChange }, tooltipContent ? /* @__PURE__ */ React__default.createElement(Box, { verticalAlign: "middle", gap: "SP1" }, /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, t(textContent)), /* @__PURE__ */ React__default.createElement(
    InfoIcon,
    {
      size: "small",
      content: t(tooltipContent),
      tooltipProps: {
        appendTo: (el) => {
          var _a;
          return Boolean((_a = el.getAttribute("data-hook")) == null ? void 0 : _a.includes("ricos-portal"));
        },
        zIndex: ZINDEX
      }
    }
  )) : /* @__PURE__ */ React__default.createElement(Text, { size: "small" }, t(textContent)));
};

export { CheckboxWithInfoIcon };
//# sourceMappingURL=checkbox-with-info-icon.js.map
